// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__utSzn","col":"CardReaderDesc_col__1MKWF","label":"CardReaderDesc_label__2H7mJ"};